import * as Sentry from '@sentry/react';

type SentryUser = {
  id: string;
  email?: string | null;
};

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

function getTracesSampleRate(): number {
  const raw = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE as string | undefined;
  if (!raw) return 0;
  const value = Number(raw);
  if (Number.isNaN(value)) return 0;
  if (value < 0) return 0;
  if (value > 1) return 1;
  return value;
}

export function initSentry(): void {
  if (!sentryDsn) return;

  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: getTracesSampleRate(),
  });
}

export function setSentryUser(user: SentryUser | null): void {
  if (!sentryDsn) return;

  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({ id: user.id, email: user.email ?? undefined });
}

export function captureException(error: unknown, context?: Record<string, unknown>): void {
  if (!sentryDsn) return;

  Sentry.withScope((scope) => {
    if (context) {
      scope.setContext('context', context);
    }
    Sentry.captureException(error);
  });
}
